import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { verifyOneTimePassword, requestNewOneTimePassword } from '../apiCalls';
import { Input } from '../Input/Input';

const MultiFactorAuthenticationForm = ({
  handleUserLoginSuccess,
  setDisplayMFAForm,
  setUserLockedOut,
  setAccessCodeErrorMessage,
  setShowContactITSupportLink,
}) => {
  const [accessCode, setAccessCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [displayRequestNewAccessCodeLink, setDisplayRequestNewAccessCodeLink] = useState(true);
  const [displayNewAccessCodeRequestComplete, setDisplayNewAccessCodeRequestComplete] = useState(false);
  const [displayNewAccessCodeInProgress, setDisplayNewAccessCodeInProgress] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const data = await verifyOneTimePassword(event.target);
      data.success === true ? handleUserLoginSuccess(data) : setErrorMessage(data.err);
      //once the account is locked out, we set teh account as locked out (so the login form display the correct message) and
      //hide the 'Your One-Time Password (OTP)' and display the 'Login' form again
      setAccessCodeErrorMessage(data?.err);
      setShowContactITSupportLink(true);
      setDisplayMFAForm(!data?.lockedOut);
      setUserLockedOut(data?.lockedOut);
    } catch (err) {
      console.error(err);
      setErrorMessage('Server error logging you.');
    }
  };

  const handleRequestNewOTPPassword = async (event) => {
    event.preventDefault();
    setDisplayRequestNewAccessCodeLink(false);

    try {
      setDisplayNewAccessCodeInProgress(true);
      const data = await requestNewOneTimePassword();
      setDisplayNewAccessCodeInProgress(false);
      data.success === true ? setDisplayNewAccessCodeRequestComplete(true) : setDisplayRequestNewAccessCodeLink(true);
    } catch (err) {
      console.error(err);
      setErrorMessage('Server error request new access code.');
      setDisplayNewAccessCodeInProgress(false);
      setDisplayNewAccessCodeRequestComplete(false);
      setDisplayRequestNewAccessCodeLink(true);
    }
  };

  const handleSuccessfullyCreateNewOTPPassword = (event) => {
    event.preventDefault();

    setDisplayNewAccessCodeRequestComplete(false);
    setDisplayRequestNewAccessCodeLink(true);
  };

  return (
    <div className="full-width-container">
      <div className="floating-box login-container">
        <h1 className="floating-box-header">Your Access Code</h1>
        <form onSubmit={handleSubmit} className="d-flex flex-column p-3 pt-0">
          <p>
            We have sent a 6 digit access code to your email. It may take a few minutes to arrive. Please enter it below
            to continue.
          </p>
          <Input
            name="otp"
            type="number"
            label="Enter your access code"
            value={accessCode}
            onChange={(e) => setAccessCode(e.target.value)}
          />
          <span className="text-danger">{errorMessage}&nbsp;</span>
          <div className="d-flex flex-column align-items-start">
            <button style={{ height: '52px', maxWidth: 'none' }} className="blue-button mx-0">
              Verify
            </button>
            <div className="status-bar">
              {displayNewAccessCodeInProgress && <span>Sending new access code, please wait...</span>}
              {displayNewAccessCodeRequestComplete && (
                <>
                  <span>New access code successfully emailed.</span>
                  <Link onClick={handleSuccessfullyCreateNewOTPPassword} className="mx-2">
                    OK
                  </Link>
                </>
              )}
              {displayRequestNewAccessCodeLink && <Link onClick={handleRequestNewOTPPassword}>Resend access code</Link>}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MultiFactorAuthenticationForm;
